import React from 'react';
import 'sanitize.css';
import { Route } from 'react-router-dom';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import DataProvider from '../DataContext/DataProvider';
import Loader from '../Loader';
import ErrorBoundary from '../ErrorBoundary';
import NavBar from '../NavBar';
import EmptyStyle from '../ui/EmptyStyle';
import UnsupportedBrowserMessage from '../ui/UnsupportedBrowserMessage';
import DropDownController from '../DropDownController';
import { ToastContainer } from 'react-toastify';
import SuggestionList from '../../components/SuggestionList'


const MainLayout = ({ component: Component, ...rest }) => {
  
  return (
    <DataProvider>
    <Loader>
      <ScrollToTop>
        <NavBar />
        <SuggestionList />
        <DropDownController/>
        <EmptyStyle />
        <ToastContainer/>
        <UnsupportedBrowserMessage />
        <div className="scrollY" id="scrollable">
        <ErrorBoundary>
        <Route {...rest} render={(props) => (
            <Component {...props} /> 
          )} />
        </ErrorBoundary>
        </div>
      </ScrollToTop>
    </Loader>
  </DataProvider>
  )
}

export default MainLayout
